import jsonLd from './functions/_jsonLd'
import frontpage from './functions/frontpage'

export default function JsonLdFrontpage () {
    return jsonLd(frontpage)
}